import { Component, OnInit } from '@angular/core';
import { GroupsService } from './groups.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.scss']
})
export class GroupsComponent implements OnInit {
  groups$: Observable<string>

  constructor(
    private gs: GroupsService
  ) { }

  ngOnInit() {
    this.groups$ = this.gs.getGroups()
  }
}
